__turbopack_context__.v({
  "content": "If0rTq_content",
  "contentContainer": "If0rTq_contentContainer",
  "root": "If0rTq_root",
});
